module.exports = __webpack_public_path__ + "img/due_data.9dbcaa98.svg";